import clickToPlayWrap from 'lib/click-to-play-wrap'
import RoomPageBase from './room-page-base'

export default class WorldDomination extends RoomPageBase {
  static handleDOMReady () {
    super.handleDOMReady()
    const video = document.querySelector('.room_description_and_details .video')
    if (video) clickToPlayWrap(video)
  }

  static get props () {
    return document.body.dataset
  }
}

WorldDomination.init()
